module.exports = __webpack_public_path__ + "public-ui/img/souz.facd4fc3.svg";